import React from 'react'
import L from 'leaflet'
import {MapControl} from 'react-leaflet'
import {defineMessages, injectIntl} from 'react-intl'
import R from 'ramda'

const toggleClass = (elm, className) => {
  if(L.DomUtil.hasClass(elm, className)){
    L.DomUtil.removeClass(elm, className)
  } else {
    L.DomUtil.addClass(elm, className)
  }
}
const toggleClassForElms = (ids, className)  => {
  const elms = ids.map(id => L.DomUtil.get(id))
  elms.forEach(elm => toggleClass(elm, className))
}
const removeClassForElms = (ids, className)  => {
  const elms = ids.map(id => L.DomUtil.get(id))
  elms.forEach(elm => L.DomUtil.removeClass(elm, className))
}
const addClassForElms = (ids, className)  => {
  const elms = ids.map(id => L.DomUtil.get(id))
  elms.forEach(elm => L.DomUtil.addClass(elm, className))
}

const m = defineMessages({
  'Services': {id:'Services', defaultMessage: 'Services'},
  'AllServices': {id:'All services', defaultMessage: 'All services'},
  'Restaurant': {id: 'Restaurant', defaultMessage: 'Restaurant' },
  'Grocery': {id:'Grocery', defaultMessage:'Grocery'},
  'Hospital': {id:'Hospital', defaultMessage:'Hospital'},
  'Public transportation': {id:'Public transportation', defaultMessage:'Public transportation'},
  'Parking': {id:'Parking', defaultMessage:'Parking'},
  'Shopping center': {id:'Shopping center', defaultMessage:'Shopping center'},

  'Transport': {id:'Transport', defaultMessage: 'Transport'},
  'Prefer walk': {id:'Prefer walk', defaultMessage: 'Prefer walk'},
  'Prefer public transportation': {id:'Prefer public transportation', defaultMessage: 'Prefer public transportation'},
  'Prefer car': {id:'Prefer car', defaultMessage: 'Prefer car'},

  'Map': {id:'Map', defaultMessage: 'Map'},
  'View search zone boundaries': {id:'View search zone boundaries', defaultMessage: 'View search zone boundaries'},

  'Interests': {id:'Interests', defaultMessage: 'Interests'},
  'Show pois': {id:'Show pois', defaultMessage: 'Show pois'},
})


const leafletControlBar = ({name, icon, map, childControls, className}) => {
  const bar = L.Control.extend({
    options: {
      position: 'topleft'
    },
    onAdd: (map) => {
      let container = L.DomUtil.create('div', 'leaflet-bar leaflet-control closed leaflet-control-custom'+' ' + className)
      container.innerHTML = `<a><i class="fa fa-fw fa-${icon}"></i><span class="leaflet-control-custom-text">${name}</span></a>`

      const buttons = childControls.map( (controlButton) => {
        const button = L.DomUtil.create('a', `leaflet-control-custom-pushable leaflet-control-custom-sub-button ${controlButton.active ? 'active' : ''}`, container)
        if(controlButton.id) {
          button.id = controlButton.id
        }
        button.innerHTML = `<span><i class="fa fa-fw fa-${controlButton.icon}"></i><span class="leaflet-control-custom-text">${controlButton.name}</span></span>`,
        button.onclick = controlButton.onClick
        return button
      })

      return container
    }
  })
  return new bar
}

class ServicesControlToInject extends MapControl {
  constructor(props){
    super(props)
    this.toggleService = this.toggleService.bind(this)
  }
  
  toggleService(serviceId, elmId){
    if(R.contains(serviceId, this.props.serviceIds)){
      removeClassForElms([elmId], 'active')
      this.props.onSetServiceIds(R.without([serviceId], this.props.serviceIds))
    } else {
      addClassForElms([elmId], 'active')
      this.props.onSetServiceIds(R.append(serviceId, this.props.serviceIds))
    }
  }
  componentWillMount() {
    this.leafletElement = leafletControlBar({
      name: this.props.intl.formatMessage(m.Services),
      map:this.props.map,
      icon: "flag",
      className: 'services',
      childControls: [
        {
          id: 'all-services',
          icon: 'check-circle-o',
          onClick: _ => {
            const services = ['restaurant', 'supermarket', 'hospital', /*'transport', 'parking',*/ 'mall']
            if(R.equals(this.props.serviceIds, services)){
              removeClassForElms(['map-service-restaurant', 'map-service-grocery', 'map-service-hospital', /*'map-service-public-transportation', 'map-service-parking',*/ 'map-service-shopping-center'], 'active')
              this.props.onSetServiceIds([])
            } else {
              addClassForElms(['map-service-restaurant', 'map-service-grocery', 'map-service-hospital', /*'map-service-public-transportation', 'map-service-parking',*/ 'map-service-shopping-center'], 'active')
              this.props.onSetServiceIds(services)
            }
          },
          name: this.props.intl.formatMessage(m.AllServices)},
        {
          id: 'map-service-restaurant',
          icon: 'cutlery',
          onClick: _ => this.toggleService('restaurant', 'map-service-restaurant'),
          name: this.props.intl.formatMessage(m.Restaurant)	
	},
        {
          id: 'map-service-grocery',
          icon: 'shopping-cart',
          onClick:  _ => this.toggleService('supermarket', 'map-service-grocery'),
          name: this.props.intl.formatMessage(m.Grocery)
        },
        {
          id: 'map-service-hospital',
          icon: 'h-square',
          onClick: _ => this.toggleService('hospital', 'map-service-hospital'),
          name: this.props.intl.formatMessage(m.Hospital)
	},
        /*{
          id: 'map-service-public-transportation',
          icon: 'bus',
          onClick: _ => this.toggleService('transport', 'map-service-public-transportation'),
          name: this.props.intl.formatMessage(m['Public transportation'])
        },
        {
          id: 'map-service-parking',
          icon: 'product-hunt',
          onClick: _ => this.toggleService('parking', 'map-service-parking'),
          name: this.props.intl.formatMessage(m.Parking)
        },*/
        {
          id: 'map-service-shopping-center',
          icon: 'shopping-bag',
          onClick: _ => this.toggleService('mall', 'map-service-shopping-center'),
          name: this.props.intl.formatMessage(m['Shopping center'])
        },
      ]
    })
  }
}
export const ServicesControl = injectIntl(ServicesControlToInject)

class TransportControlToInject extends MapControl {
  componentWillMount() {
    this.leafletElement = leafletControlBar({
      className: 'transport',
      name: this.props.intl.formatMessage(m.Transport),
      map:this.props.map,
      icon: "car",
      childControls: [
        {icon: 'male', name: this.props.intl.formatMessage(m['Prefer walk']), onClick},
        {icon: 'bus',  name: this.props.intl.formatMessage(m['Prefer public transportation']), onClick},
        {icon: 'car',  name: this.props.intl.formatMessage(m['Prefer car']), onClick},
      ]
    })
  }
}
export const TransportControl = injectIntl(TransportControlToInject)


class MapModControlToInject extends MapControl {
  componentWillMount() {
      
    this.leafletElement = leafletControlBar({
      name:this.props.intl.formatMessage(m.Map),
      className: 'map',    
      map:this.props.map,
      icon: "map",
      childControls: [
        {
          icon: 'map', 
          name: this.props.intl.formatMessage(m['View search zone boundaries']), 
          onClick: _ => {
            toggleClassForElms(['map-search-boundaries'], 'active')
            this.props.toggleShowPositioningBounds()
          }, 
          id: 'map-search-boundaries'
        },
      ]
    })
  }
}

export const MapModControl = injectIntl(MapModControlToInject)




/** WEBPACK FOOTER **
 ** ./app/components/LeafletControls.js
 **/